import { css } from 'linaria';

export const OrganizationNameClassName = css`
  font-weight: 600;
`;

export const ContentClassName = css`
  display: flex;
  flex-direction: column;
  width: 300px;

  @media (--only-mobile) {
    width: 100%;
  }
`;
